import { NEXT_LOCALES } from '@beat-venues/common-types';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enJSON from '../locales/en.json';
import frJSON from '../locales/fr.json';
import nlJSON from '../locales/nl.json';
import { getCookie } from './cookie-utils';

let DEFAULT_LANGUAGE = 'nl';
const SUPPORTED_LANGUAGES = [
    'nl',
    'fr',
    'en',
] as unknown as typeof NEXT_LOCALES;
const userLanguage = getCookie('lang') as
    | typeof SUPPORTED_LANGUAGES[number]
    | undefined;
const pathLanguage = window.location.pathname.split('/').filter((n) => n)[0] as
    | typeof NEXT_LOCALES[number]
    | undefined;

if (
    typeof userLanguage !== 'undefined' &&
    SUPPORTED_LANGUAGES.includes(userLanguage)
) {
    DEFAULT_LANGUAGE = userLanguage.split(
        '-'
    )[0] as typeof NEXT_LOCALES[number];
} else {
    console.log(
        '[language manager] This user-language is not supported: ',
        userLanguage
    );
}

if (
    typeof pathLanguage !== 'undefined' &&
    NEXT_LOCALES.includes(pathLanguage)
) {
    DEFAULT_LANGUAGE = pathLanguage as typeof NEXT_LOCALES[number];
} else {
    console.log(
        '[language manager] This path-language is not supported: ',
        pathLanguage
    );
}

console.log(
    '[language manager] setting language to default: ',
    DEFAULT_LANGUAGE
);

i18n.use(initReactI18next).init({
    lng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    fallbackLng: SUPPORTED_LANGUAGES,
    resources: {
        nl: { ...nlJSON },
        fr: { ...frJSON },
        en: { ...enJSON },
    },
});

export { i18n as default, DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES };
